<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>

                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>

        <div class="flex flex-col mt-1">
            <div
                v-if="activeFilters.includes('keyword')"
                class="md:w-6/12 w-8/12 mx-auto mb-4"
            >
                <custom-input
                    v-model="keyword"
                    type="text"
                    placeholder="Buscar por palabra clave .."
                    class="mr-2"
                    @blur="applyFilter"
                    @enter="onEnter"
                >
                    <template #icon> 🔎 </template>
                </custom-input>
            </div>

            <div
                v-if="activeFilters.includes('active')"
                class="md:w-6/12 w-8/12 mx-auto mb-4 flex justify-center"
            >
                <span>Activo &nbsp;</span>
                <custom-checkbox v-model="active" warn @input="applyFilter" />
            </div>

            <div
                v-if="activeFilters.includes('highlightType')"
                class="md:w-6/12 w-8/12 mx-auto mb-4 flex justify-center"
            >
                <highlight-types-selector
                    v-model="highlightType"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('type')"
                class="md:w-6/12 w-8/12 mx-auto mb-4"
            >
                <line-hierarchy-type-selector
                    v-model="type"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('line')"
                class="md:w-6/12 w-8/12 mx-auto mb-4"
            >
                <line-selector
                    v-model="line"
                    :default-filters="{}"
                    enabled
                    label="Categoría padre"
                    show-label
                    @change="applyFilter"
                />
            </div>
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros
                    </h3>

                    <app-button
                        :disabled="!filters.length"
                        @click="isOpenModal = false"
                    >
                        ✔️ Aplicar filtros ({{ filters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector v-model="filters" :base="baseFilters" />
        </app-dialog>
    </div>
</template>

<script>
import { linesFilters } from "@/common/fields/filters-query";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import HighlightTypesSelector from "@/components/utils/HighlightTypesSelector.vue";

export default {
    name: "LinesFilters",
    components: {
        AppDialog,
        CardsSelector,
        CustomInput,
        HighlightTypesSelector,
        LineHierarchyTypeSelector: () =>
            import("@/components/lines/LineHierarchyTypeSelector.vue"),
        LineSelector: () => import("@/components/lines/LineSelector.vue")
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        enabledFilters: {
            default: () => [
                "keyword",
                "active",
                "highlightType",
                "type",
                "line"
            ],
            type: Array,
            require: true
        },
        defaultFilters: {
            default: () => [],
            type: Array,
            require: true
        }
    },
    emits: ["change", "enter"],
    data: () => ({
        activeFilters: [],
        isOpenModal: false,
        keyword: "",
        highlightType: "",
        active: true,
        type: "line",
        line: { slug: "", name: "" },
        filters: [],
        baseFilters: []
    }),
    watch: {
        enabledFilters(value) {
            this.setEnabledFilters(value);
        }
    },
    created() {
        this.setEnabledFilters(this.enabledFilters);
    },
    mounted() {
        this.setInput(this.itemsCurrent);
        if (!this.activeFilters.length) {
            this.activeFilters = [...this.defaultFilters];
        }
        this.applyFilter();
    },
    methods: {
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.activeFilters = [...this.filters];
            this.applyFilter();
        },
        applyFilter() {
            this.$emit("change", {
                ...{
                    ...(this.activeFilters.includes("keyword")
                        ? { keyword: this.keyword }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("active")
                        ? { active: this.active }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("highlightType")
                        ? { highlightType: this.highlightType }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("type")
                        ? { type: this.type }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("line")
                        ? { lineSlug: this.line.slug }
                        : null)
                }
            });
        },
        onEnter() {
            this.applyFilter();
            this.$emit("enter");
        },
        setInput(value) {
            const filters = Object.keys(value);
            this.activeFilters = filters;
            this.filters = filters;
            if ("keyword" in value) this.keyword = value.keyword;
            if ("active" in value) this.active = value.active;
            if ("highlightType" in value) {
                this.highlightType = value.highlightType;
            }
            if ("type" in value) this.type = value.type;
            if ("lineSlug" in value) {
                this.line = { slug: value.lineSlug, name: value.lineSlug };
            }
        },
        setEnabledFilters(value) {
            this.baseFilters = linesFilters.filter((item) => {
                const hasPermission =
                    !item.permissions ||
                    item.permissions.every((permission) =>
                        this.$ability.hasPermission(permission)
                    );
                return (
                    value.includes(item.id) &&
                    (item.show === undefined || item.show) &&
                    hasPermission
                );
            });
        }
    }
};
</script>
